import { render } from "./Sucesso.vue?vue&type=template&id=3d19c6ee"
import script from "./Sucesso.vue?vue&type=script&lang=js"
export * from "./Sucesso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__